import confetti from 'canvas-confetti';

export function triggerConfetti(options = {}) {
  const defaults = {
    particleCount: 100,
    spread: 70,
    origin: { y: 0.6 },
    colors: ['#8b5cf6', '#ec4899', '#f59e0b', '#10b981']
  };

  confetti({
    ...defaults,
    ...options
  });
}

export function triggerCelebration() {
  // Fire from left
  confetti({
    particleCount: 50,
    angle: 60,
    spread: 55,
    origin: { x: 0, y: 0.6 },
    colors: ['#8b5cf6', '#ec4899', '#f59e0b']
  });
  
  // Fire from right
  confetti({
    particleCount: 50,
    angle: 120,
    spread: 55,
    origin: { x: 1, y: 0.6 },
    colors: ['#8b5cf6', '#ec4899', '#f59e0b']
  });
}

export function triggerStars() {
  const count = 50;
  const defaults = {
    origin: { y: 0.7 },
    shapes: ['star'],
    colors: ['#FFD700', '#FFA500', '#FF6347']
  };

  function fire(particleRatio, opts) {
    confetti({
      ...defaults,
      particleCount: Math.floor(count * particleRatio),
      ...opts
    });
  }

  fire(0.25, { spread: 26, startVelocity: 55 });
  fire(0.2, { spread: 60 });
  fire(0.35, { spread: 100, decay: 0.91, scalar: 0.8 });
  fire(0.1, { spread: 120, startVelocity: 25, decay: 0.92, scalar: 1.2 });
}
